import React, {useContext, useEffect, useState} from "react";
import {SiteContext} from "../../utils/SiteContext";
import {GetUserDetails} from "../../utils/AxiosUtils";
import Grid from "@mui/material/Grid";
import AccountDetails from "./AccountDetails";
import ChangePassword from "./ChangePassword";
import {PageContentArea} from "../../site components/PageContentArea";
import {Box, Paper} from "@mui/material";

const leftSide = (userDetails) => {
    return (
        <Grid container gap={2} sx={{height: '100%'}}>
            <Grid item xs={12} sx={{minHeight: '435px'}}>
                <Paper sx={{height: '100%', padding: 1}}>
                    <AccountDetails userDetail={userDetails}/>
                </Paper>
            </Grid>
            <Grid item xs={12} sx={{minHeight: '265px'}}>
                <Paper sx={{height: '100%', padding: 1}}>
                    <ChangePassword />
                </Paper>
            </Grid>
        </Grid>
    )
}


export default function AccountPage() {
    const {userInfo} = useContext(SiteContext);
    const [userDetails, setUserDetails] = useState({});
    const [user,] = userInfo;

    useEffect(() => {
        GetUserDetails(user.id, setUserDetails);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])
    return (
        <Box sx={{ height: `calc(100vh - 110px)`, display: 'flex', flexDirection: 'column' }}>
            <Grid container gap={2} sx={{height: '100%'}}>
                <Grid item xs={12} md={4} sx={{height: '100%'}}>
                    {leftSide([userDetails, setUserDetails])}
                </Grid>
            </Grid>
        </Box>
    )
}